// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__U_4ug","iconWithCounter":"styles_iconWithCounter__1aIRY","counterForLabel":"styles_counterForLabel__GPaY6","counterForIcon":"styles_counterForIcon__Sm6fW"};